import ListGroup from "react-bootstrap/ListGroup";
import Card from "react-bootstrap/Card";
import { Col } from "react-bootstrap";
import BitrixApi from "../../../../API/BitrixApi";
import ZustandAlert from "../../../../Zustand/ZustandAlert";
import useStore from "../../../../Zustand/Zustand";
import ZustandProductCgi from "../../../../Zustand/ZustandProductCgi";
import ZustandFormImovel from "../../../../Zustand/ZustandFormImovel";
import convertToFloat from "../../../../Utils/convertToFloat";

const BoxSimulationMobileHighlight = (props) => {
  const { triggerSuccess } = ZustandAlert();
  const {
    nomeCompleto,
    cpf,
    idadeCliente,
    emailPrincipal,
    linkSimulacao,
    numero,
    isLoadingDowloadSimulation,
  } = useStore();
  const { valorFGTS, valorDeEntrada, valorDoImovel } = ZustandFormImovel();
  const { cgi } = ZustandProductCgi();

  const valorFinaciamento = convertToFloat(
    valorDoImovel - valorDeEntrada - valorFGTS
  );

  const valorImovel = convertToFloat(valorDoImovel);

  const bank = props.src;
  return (
    <div className="d-flex justify-content-center align-items-center text-center">
      <Card
        style={{ width: "18rem", borderColor: "#555af8" }}
        className="mx-auto"
      >
        <Card.Header
          style={{
            fontFamily: "Inter",
            backgroundColor: "#555af8",
            color: "#fff",
            height: "45px",
          }}
        >
          Melhor Opção
        </Card.Header>
        <ListGroup variant="flush">
          <ListGroup.Item className="text-center">
            <img
              src={props.src}
              alt="Logo Icon"
              style={{ width: "auto", height: "auto" }}
            />
          </ListGroup.Item>
          <ListGroup.Item className="text-center">
            <TitleNameCard name="RELACIONAMENTO" />
            <div className="d-flex justify-content-center align-items-center">
              <RelationText name={props.relation} />
              <TaxBadge value={props.tax} />
            </div>
          </ListGroup.Item>
          <ListGroup.Item className="text-center">
            <TitleNameCard name="PRAZO" />
            <MensageCard msg={props.term} />
          </ListGroup.Item>
          <ListGroup.Item className="text-center">
            <TitleNameCard name="PRIMEIRA PARCELA" />
            <MensageCard msg={props.firstInstallment} />
          </ListGroup.Item>
          <ListGroup.Item className="text-center">
            <TitleNameCard name="ÚLTIMA PARCELA" />
            <MensageCard msg={props.lastInstallment} />
          </ListGroup.Item>
          <ListGroup.Item>
            <TitleNameCard name="TAXA EFETIVA" />
            <MensageCard msg={props.effectiveRate} />
          </ListGroup.Item>
          <ListGroup.Item className="text-center">
            <TitleNameCard name="SEGURADORA" />
            <MensageCard msg={props.insuranceCompany} />
          </ListGroup.Item>
          <ListGroup.Item className="text-center">
            <TitleNameCard name="CET" />
            <MensageCard msg={props.cet} />
          </ListGroup.Item>
          <ListGroup.Item className="mb-1 text-center ">
            <button
              disabled={isLoadingDowloadSimulation}
              className="shared-button-site"
              onClick={() =>
                BitrixApi({
                  bank,
                  nomeCompleto,
                  cpf,
                  idadeCliente,
                  emailPrincipal,
                  numero,
                  linkSimulacao,
                  cgi,
                  triggerSuccess,
                  valorImovel,
                  valorFinaciamento,
                })
              }
            >
              {!isLoadingDowloadSimulation
                ? "Cadastrar Proposta"
                : "Carregando... "}
            </button>
          </ListGroup.Item>
        </ListGroup>
      </Card>
    </div>
  );
};

const RelationText = ({ name }) => (
  <span
    style={{
      fontFamily: "Inter",
      fontSize: "14px",
      fontWeight: "400",
      color: "rgba(0, 0, 0, 0.80)",
      paddingInlineStart: "10px",
      paddingInlineEnd: "6px",
    }}
  >
    {name}
  </span>
);

const TaxBadge = ({ value }) => <span className="tax-badge">{value}</span>;

const TitleNameCard = ({ name }) => (
  <Col
    style={{
      fontFamily: "Inter",
      fontSize: "12px",
      fontWeight: "400",
      color: "#7F7F7F",
    }}
  >
    {name}
  </Col>
);

const MensageCard = ({ msg }) => (
  <Col
    style={{
      fontFamily: "Inter",
      fontSize: "14px",
      fontWeight: "400",
      color: "rgba(0, 0, 0, 0.80)",
    }}
  >
    {msg}
  </Col>
);

export default BoxSimulationMobileHighlight;
